import { compose, withHandlers, withState, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import { fetchAnalyticsData } from '../actions';
import {
  getActiveBrandId,
  getBarberUserId,
  getShop,
} from '../../../../auth/selectors';
import { getIsFetching } from '../selectors';
import { getShopFilterForApi } from '../../filters/ShopFilter/selectors';
import { ChurnZeroService, RUN_ANALYTICS_REPORT } from '../../../../../modules/infra/observability/churnzero';

const initialFilters = {
  firstFrom: null,
  firstTo: null,
  secondFrom: null,
  secondTo: null,
  selectedBarberId: null,
};

export default compose(
  withState('filters', 'setFilters', initialFilters),
  connect(
    state => ({
      shopId: getShop(state),
      barberId: getBarberUserId(state),
      isFetching: getIsFetching(state),
      brandId: getActiveBrandId(state),
      shopFilter: getShopFilterForApi(state),
    }),
    { fetchAnalyticsData }
  ),
  withHandlers({
    fetch: props => (filters) => {
      if (props.isFetching) return;
      const barberId = filters.selectedBarberId;
      props.fetchAnalyticsData(
        props.shopId,
        props.barberId || barberId,
        'first',
        filters.firstFrom,
        filters.firstTo,
        props.brandId,
        props.shopFilter
      );
      props.fetchAnalyticsData(
        props.shopId,
        props.barberId || barberId,
        'second',
        filters.secondFrom,
        filters.secondTo,
        props.brandId,
        props.shopFilter
      );

      if (filters.firstFrom && filters.firstTo && filters.secondFrom && filters.secondTo) {
        ChurnZeroService.track(RUN_ANALYTICS_REPORT);
      }
    },
  }),
  withPropsOnChange(['shopFilter'], (props) => {
    props.fetch(props.filters);
  })
);
